import React from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function avatarSrc(p) {
  const a = p?.avatar;
  if (!a) return null;
  return a.startsWith("/api") ? `${BACKEND_URL}${a}` : a;
}

export function Avatar({ profile, size = "w-11 h-11", text = "", className = "", testId }) {
  const src = avatarSrc(profile);
  const base = `${size} rounded-full overflow-hidden shrink-0 ${className}`;
  if (src) return <img src={src} alt={profile?.name || ""} className={`${base} block object-cover`} data-testid={testId} />;
  return <div className={`${base} flex items-center justify-center font-display font-bold bg-gradient-to-br from-cyan-400/30 to-fuchsia-500/30 ${text}`} data-testid={testId}>{(profile?.name || profile?.display_name || "?")[0]?.toUpperCase()}</div>;
}
